import { Application } from "src/models/application";
import { createEntityModel } from "src/store/models/entity/_shared";

export const ApplicationEntityModel = createEntityModel<Application>();
